"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_authentication_service_1 = require("./http-authentication.service");
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var cookie_service_1 = require("../cookie-service");
var model_1 = require("../../model");
var http_url_standard_encoding_spec_1 = require("../util/http-url-standard-encoding-spec");
var operators_1 = require("rxjs/operators");
var auth_settings_config_1 = require("./auth-settings.config");
var login_responses_enum_1 = require("./login-responses.enum");
var of_1 = require("rxjs/observable/of");
/**
 * Authentication service implementation which uses access token as cookie.
 *
 * @author Team Skynet
 * @since 3.16.0
 */
var CookieBasedAuthenticationService = /** @class */ (function (_super) {
    __extends(CookieBasedAuthenticationService, _super);
    function CookieBasedAuthenticationService(http, appProperties, cookieService) {
        var _this = _super.call(this, http, appProperties, cookieService) || this;
        _this.http = http;
        _this.appProperties = appProperties;
        _this.cookieService = cookieService;
        if (_this.cookieService.check(auth_settings_config_1.AuthSettings.TOKEN_KEY_NAME)) {
            _this.cookieService.delete(auth_settings_config_1.AuthSettings.TOKEN_KEY_NAME, '/');
        }
        return _this;
    }
    CookieBasedAuthenticationService_1 = CookieBasedAuthenticationService;
    CookieBasedAuthenticationService.getInstance = function (http, appProperties, cookieService) {
        if (this._instance === undefined) {
            this._instance = new CookieBasedAuthenticationService_1(http, appProperties, cookieService);
        }
        return this._instance;
    };
    CookieBasedAuthenticationService.prototype.login = function (username, password) {
        var _this = this;
        var httpParams = new http_1.HttpParams({
            encoder: new http_url_standard_encoding_spec_1.HttpUrlStandardEncodingCodec(),
        })
            .set('grant_type', 'password')
            .set('username', username)
            .set('password', password)
            .set('csrf', 'true');
        this.setUsername(username);
        var options = this.oauthClientHeaders();
        return this.authServiceUrl.pipe(operators_1.switchMap(function (url) {
            return _this.http.post(url + auth_settings_config_1.AuthSettings.LOGIN_ENDPOINT, httpParams, options);
        }), operators_1.switchMap(function (response) {
            if (response.status === 200) {
                var body = response.body;
                if (body && body['X-XSRF-TOKEN']) {
                    _this.setCsrfToken(body['X-XSRF-TOKEN']);
                }
                if (body['isNeedVerification']) {
                    return of_1.of(new model_1.LoginResponse(login_responses_enum_1.LoginResponseType.NEED_VERIFICATION, '', [], body['verificationType']));
                }
                return _this.userDataObservable().pipe(operators_1.map(function () {
                    _this.loggedOn.next(true);
                    return new model_1.LoginResponse(login_responses_enum_1.LoginResponseType.SUCCESS);
                }));
            }
            else {
                return of_1.of(new model_1.LoginResponse(login_responses_enum_1.LoginResponseType.FAILED, 'auth_bad_credentials'));
            }
        }), operators_1.catchError(function (httpErrorResponse) {
            return httpErrorResponse.status === 404
                ? _super.prototype.login.call(_this, username, password)
                : of_1.of(_this.handleLoginError(httpErrorResponse.error, httpErrorResponse.status));
        }));
    };
    CookieBasedAuthenticationService.prototype.checkToken = function () {
        var _this = this;
        this.userDataObservable()
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function () { return _this.loggedOn.next(true); }, function (error) {
            _this.loggedOn.next(false);
            _this.checkIfUserIsGuest(undefined);
            console.error(error);
        });
    };
    CookieBasedAuthenticationService.prototype.oauthClientHeaders = function () {
        var options = _super.prototype.oauthClientHeaders.call(this);
        var headers = options.headers;
        var csrfToken = this.getCsrfToken();
        if (csrfToken) {
            headers = headers.append('X-XSRF-TOKEN', csrfToken);
        }
        return {
            headers: headers,
            observe: options.observe,
            withCredentials: true,
        };
    };
    CookieBasedAuthenticationService.prototype.setCsrfToken = function (csrfToken) {
        this.csrfToken = csrfToken;
        localStorage.setItem(auth_settings_config_1.AuthSettings.CSRF_TOKEN_KEY_NAME, csrfToken);
    };
    CookieBasedAuthenticationService.prototype.getCsrfToken = function () {
        return (this.csrfToken ||
            localStorage.getItem(auth_settings_config_1.AuthSettings.CSRF_TOKEN_KEY_NAME));
    };
    CookieBasedAuthenticationService = CookieBasedAuthenticationService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            cookie_service_1.CookieService])
    ], CookieBasedAuthenticationService);
    return CookieBasedAuthenticationService;
    var CookieBasedAuthenticationService_1;
}(http_authentication_service_1.HttpAuthenticationService));
exports.CookieBasedAuthenticationService = CookieBasedAuthenticationService;
//# sourceMappingURL=cookie-based-authentication.service.js.map